/* eslint-disable */
import { Injectable } from '@angular/core';
import { Logout } from '../helpers/usm-commands';
import { UsmMessage } from '../helpers/usm-message';
import XmlToJsonParser from '../helpers/usm-xml-json-parser';
import {
  CallInfo,
  ConferenceInfo,
  GlobalInfo,
  Profile,
  ProfileInfo,
  ProfileStatsInfo,
  SessionInfo,
  SessionStatsInfo,
  StatsInfo,
  TransferInfo,
  TransferOptionsValues,
} from '../models/usm-objects';
@Injectable({
  providedIn: 'root',
})
export class USMService {
  constructor() {}
  callbackInfo = {
    totalDue: '',
    totalFuture: '',
    totalPast: '',
    totalToday: '',
  };
  globalInfo!: GlobalInfo;
  profilesInfo!: ProfileInfo;
  manualProfile!: number;
  sessionInfo!: SessionInfo;
  statsInfo!: StatsInfo;
  profileStatsInfo!: ProfileStatsInfo[];
  sessionStatsInfo!: SessionStatsInfo;
  usmSocket!: WebSocket | null;
  callInfo!: CallInfo;
  conferenceInfo!: ConferenceInfo;
  transferInfo!: TransferInfo;
  contactList: any[] = [];
  reset() {
    this.callInfo = {} as CallInfo;
    this.profilesInfo = {
      Profiles: [],
    };
    this.sessionInfo = {} as SessionInfo;
    this.statsInfo = {} as StatsInfo;
    this.globalInfo = {} as GlobalInfo;
    this.conferenceInfo = {} as ConferenceInfo;
    this.profileStatsInfo = [];
    this.sessionStatsInfo = {} as SessionStatsInfo;
  }
  postCallReset() {
    this.callInfo = {} as CallInfo;
    this.sessionInfo = {} as SessionInfo;
    this.statsInfo = {} as StatsInfo;
    this.globalInfo = {} as GlobalInfo;
    this.conferenceInfo = {} as ConferenceInfo;
    this.transferInfo = {} as TransferInfo;
    this.profileStatsInfo = [];
    this.sessionStatsInfo = {} as SessionStatsInfo;
    this.contactList = [];
    console.log('Resetting all the data....');
  }
  callInfoReset() {
    this.callInfo = {} as CallInfo;
    this.conferenceInfo = {} as ConferenceInfo;
    this.transferInfo = {} as TransferInfo;
    this.contactList = [];
  }
  handleResponseInfo(usmMessage: UsmMessage) {
    if (usmMessage.HasFailed) {
      return;
    }

    // success
    if (usmMessage?.RawMessage?.indexOf('<CallbackData>') !== -1) {
      console.log('CallbackData');
    } else if (usmMessage.RawMessage.indexOf('<CallbackContactData>') !== -1) {
      console.log('CallbackContactData');
    } else if (usmMessage.RawMessage.indexOf('<CallbackInfo>') !== -1) {
      this.handleResponseInfoCallback(usmMessage);
    } else if (usmMessage.RawMessage.indexOf('<GlobalInfo>') !== -1) {
      this.handleResponseInfoGlobal(usmMessage);
    } else if (usmMessage.RawMessage.indexOf('<ProfileInfo') !== -1) {
      this.handleResponseInfoProfile(usmMessage);
    } else if (usmMessage.RawMessage.indexOf('<SessionInfo>') !== -1) {
      this.handleResponseInfoSession(usmMessage);
    } else if (usmMessage.RawMessage.indexOf('<StatsInfo>') !== -1) {
      this.handleResponseInfoStats(usmMessage);
    }
  }
  handleResponseInfoCallback(usmMessage: UsmMessage) {
    const text = usmMessage?.Data?.Data;
    if (text) {
      const callbackInfoJson = new XmlToJsonParser();
      callbackInfoJson.Parse(text);

      this.callbackInfo.totalDue =
        callbackInfoJson.JsonObject?.CallbackInfo.Count['@attributes']['Due'];
      this.callbackInfo.totalFuture =
        callbackInfoJson.JsonObject?.CallbackInfo.Count['@attributes'][
          'Future'
        ];
      this.callbackInfo.totalPast =
        callbackInfoJson.JsonObject?.CallbackInfo.Count['@attributes']['Past'];
      this.callbackInfo.totalToday =
        callbackInfoJson.JsonObject?.CallbackInfo.Count['@attributes']['Today'];
    }
  }
  handleResponseInfoGlobal(usmMessage: UsmMessage) {
    const text = usmMessage?.Data?.Data;
    if (text) {
      const globalInfoJson = new XmlToJsonParser();
      globalInfoJson.Parse(text);
      this.globalInfo = {
        DndStates: [],
      };

      if (
        typeof globalInfoJson.JsonObject?.GlobalInfo?.DndStates.DndState !==
        'undefined'
      ) {
        if (
          typeof globalInfoJson.JsonObject?.GlobalInfo?.DndStates.DndState
            .length === 'undefined'
        ) {
          const dndState =
            globalInfoJson.JsonObject?.GlobalInfo.DndStates.DndState;
          this.globalInfo.DndStates.push({
            name: dndState['@attributes']['name'],
            value: 'DND-' + dndState['@attributes']['name'],
          });
        } else {
          for (const bb in globalInfoJson.JsonObject.GlobalInfo.DndStates
            .DndState) {
            const dndState =
              globalInfoJson.JsonObject.GlobalInfo.DndStates.DndState[bb];
            this.globalInfo.DndStates.push({
              name: dndState['@attributes']['name'],
              value: 'DND-' + dndState['@attributes']['name'],
            });
          }
        }
      }
    }
  }
  createProfile(jsonProfileInfo: any) {
    const profile: Profile = this.initializeProfile();

    this.setProfileAttributes(profile, jsonProfileInfo);
    this.setCampaign(profile, jsonProfileInfo);
    this.setDispositions(profile, jsonProfileInfo);
    this.setTransferOptions(profile, jsonProfileInfo);

    return profile;
  }

  private initializeProfile(): Profile {
    return {
      id: '',
      name: '',
      type: '',
      agentScreenContext: '',
      controlledRecording: false,
      hasAgentScreenContext: false,
      customScriptingUrl: '',
      hasCustomScripting: false,
      disallowManualCalls: false,
      loadCustomScripting: false,
      externalScript: false,
      campaign: {
        callbackColumns: [],
        id: '',
        indexedColumns: [],
        name: '',
      },
      dispositions: [],
      transferOptions: [],
      externalScriptIsRedirect: false,
      isPlayConnection: false,
    };
  }

  private setProfileAttributes(profile: Profile, jsonProfileInfo: any): void {
    const attributes = jsonProfileInfo['@attributes'];
    profile.id = attributes['profileId'];
    profile.name = attributes['profileName'];
    profile.type = attributes['profileType'];
    profile.agentScreenContext = attributes['agentScreenContext'];
    profile.hasAgentScreenContext = profile.agentScreenContext.length > 0;
    profile.controlledRecording = this.toBoolean(
      attributes['profileControlledRecording']
    );
    profile.customScriptingUrl = attributes['customScriptingUrl'] ?? '';
    profile.hasCustomScripting = !!profile.customScriptingUrl;
    profile.externalScript = this.toBoolean(attributes['externalScript']);
    profile.disallowManualCalls = this.toBoolean(
      attributes['disallowManualCalls']
    );
    profile.loadCustomScripting = this.toBoolean(
      attributes['loadCustomScripting']
    );
    profile.externalScriptIsRedirect = this.toBoolean(
      attributes['externalScriptRedirect']
    );
    profile.isPlayConnection = this.toBoolean(
      attributes['profilePlayConnectionSound']
    );
  }

  private setCampaign(profile: Profile, jsonProfileInfo: any): void {
    const attributes = jsonProfileInfo['@attributes'];
    const campaign = {
      id: attributes['campaignId'],
      name: attributes['campaignName'],
      callbackColumns: this.splitString(attributes['callbackColumns']),
      indexedColumns: this.splitString(attributes['indexedColumns']),
    };
    profile.campaign = campaign;
  }

  private setDispositions(profile: Profile, jsonProfileInfo: any): void {
    profile.dispositions = [];
    const dispositions = jsonProfileInfo.Disposition;

    if (dispositions) {
      const dispositionsArray = Array.isArray(dispositions)
        ? dispositions
        : [dispositions];

      dispositionsArray.forEach(disposition => {
        const type = disposition.type ?? disposition['@attributes']?.['type'];
        const name = disposition.name ?? disposition['@attributes']?.['name'];
        const description =
          disposition.description ??
          disposition['@attributes']?.['description'];
        if (type && name && description) {
          profile.dispositions.push({ type, name, description });
        }
      });
    }
  }

  private setTransferOptions(profile: Profile, jsonProfileInfo: any): void {
    profile.transferOptions = [];
    const transferOptions = jsonProfileInfo?.TransferOptions;

    if (transferOptions) {
      Object.keys(transferOptions).forEach(optionKey => {
        switch (optionKey) {
          case 'Profiles':
            this.addProfileTransferOptions(profile, transferOptions.Profiles);
            break;
          case 'OutsideNumbers':
            this.addOutsideNumberTransferOptions(
              profile,
              transferOptions.OutsideNumbers
            );
            break;
          case 'Users':
            this.addUserTransferOptions(profile, transferOptions.Users);
            break;
          case '@attributes':
            this.addDialPadOption(profile, transferOptions['@attributes']);
            break;
        }
      });
    }
  }

  private addProfileTransferOptions(profile: Profile, profiles: any): void {
    const profileOptions = this.extractTransferOptions(
      profiles.Profile,
      'CHANNEL_ROUTE'
    );
    if (profileOptions.length) {
      profile.transferOptions.push({
        type: 'CHANNEL_ROUTE',
        name: 'Channel Route',
        value: profileOptions,
      });
    }
  }

  private addOutsideNumberTransferOptions(
    profile: Profile,
    outsideNumbers: any
  ): void {
    const outsideOptions = this.extractTransferOptions(
      outsideNumbers.OutsideNumber,
      'OUTSIDE_NUMBER'
    );
    if (outsideOptions.length) {
      profile.transferOptions.push({
        type: 'OUTSIDE_NUMBER',
        name: 'Outside Number',
        value: outsideOptions,
      });
    }
  }

  private addUserTransferOptions(profile: Profile, users: any): void {
    const userOptions = this.extractTransferOptions(users.User, 'USERS');
    if (userOptions.length) {
      profile.transferOptions.push({
        type: 'USERS',
        name: 'User',
        value: userOptions,
      });
    }
  }

  private addDialPadOption(profile: Profile, attributes: any): void {
    const isEnabled = attributes?.enabledialpad === 'True';
    if (isEnabled) {
      profile.transferOptions.push({
        name: 'DIAL PAD',
        type: 'DIAL_PAD',
        value: isEnabled,
      });
    }
  }

  private extractTransferOptions(
    items: any,
    type: string
  ): TransferOptionsValues[] {
    const options: TransferOptionsValues[] = [];
    const itemsArray = Array.isArray(items) ? items : [items];

    itemsArray.forEach(item => {
      options.push({
        type,
        name:
          item['@attributes']['Name'] ??
          item['@attributes']['UserName'] ??
          item['@attributes']['ProfileName'],
        value:
          item['@attributes']['PhoneNumber'] ??
          item['@attributes']['Extension'] ??
          item['@attributes']['ProfileId'],
        countryCode: item['@attributes']['CountryCode'] ?? '+1',
      });
    });

    return options;
  }

  private toBoolean(value: any): boolean {
    return value?.toLowerCase() === 'true';
  }

  private splitString(value: string): string[] {
    return value ? value.split(',') : [];
  }

  createContact(jsonContact: any, contactType: any) {
    let contact = {
      attributes: new Array(),
      data: '',
      id: '',
      fullName: '',
      number: '',
      firstName: '',
      lastName: '',
      city: '',
      state: '',
      zip: '',
    };

    contact.data = jsonContact;
    contact.id = jsonContact['@attributes']['contactId'];

    if (contactType === 'Callback') {
      contact.fullName = jsonContact['@attributes']['fullName'];
      contact.number = jsonContact['@attributes']['contactNumber'] + 'Allo';

      contact.attributes = new Array();
      for (const attributeName in jsonContact['@attributes']) {
        const attributeValue = jsonContact['@attributes'][attributeName];
        let contactAttribute = {
          name: attributeName,
          value: attributeValue,
        };
        contact.attributes.push(contactAttribute);
      }
    } else if (contactType === 'ContactList') {
      contact.number = jsonContact['@attributes']['number'];
      contact.firstName = jsonContact['@attributes']['firstName'];
      contact.lastName = jsonContact['@attributes']['lastName'];
      contact.city = jsonContact['@attributes']['city'];
      contact.state = jsonContact['@attributes']['state'];
      contact.zip = jsonContact['@attributes']['zip'];
      contact.fullName = contact.firstName + ' ' + contact.lastName;
    }
    return contact;
  }
  handleContacts(usmMessage: UsmMessage) {
    this.contactList = [];
    const text = usmMessage.Data.ContactList;
    const contactListDataJson = new XmlToJsonParser();
    contactListDataJson.Parse(text);
    if (
      typeof contactListDataJson.JsonObject.ContactList.Contact !== 'undefined'
    ) {
      if (
        typeof contactListDataJson.JsonObject.ContactList.Contact.length ===
        'undefined'
      ) {
        const contact = contactListDataJson.JsonObject.ContactList.Contact;
        this.contactList.push(this.createContact(contact, 'ContactList'));
      } else {
        for (const bb in contactListDataJson.JsonObject.ContactList.Contact) {
          const contact =
            contactListDataJson.JsonObject.ContactList.Contact[bb];
          this.contactList.push(this.createContact(contact, 'ContactList'));
        }
      }
    }
  }
  handleResponseInfoProfile(usmMessage: UsmMessage) {
    const text = usmMessage.Data.Data;
    const profileInfoJson = new XmlToJsonParser();
    profileInfoJson.Parse(text);

    this.profilesInfo = {
      Profiles: [],
    };
    if (typeof profileInfoJson.JsonObject.ProfileInfo.Profile === 'object') {
      if (
        typeof profileInfoJson.JsonObject.ProfileInfo.Profile.length ===
        'undefined'
      ) {
        this.profilesInfo.Profiles.push(
          this.createProfile(profileInfoJson.JsonObject.ProfileInfo.Profile)
        );
      } else {
        for (const i in profileInfoJson.JsonObject.ProfileInfo.Profile) {
          this.profilesInfo.Profiles.push(
            this.createProfile(
              profileInfoJson.JsonObject.ProfileInfo.Profile[i]
            )
          );
        }
      }
    }
    console.log(this.profilesInfo);
  }

  handleResponseInfoSession(usmMessage: UsmMessage) {
    const text = usmMessage.Data.Data;
    const sessionInfoJson = new XmlToJsonParser();
    sessionInfoJson.Parse(text);
    this.sessionInfo = {} as SessionInfo;
    const propertyLength =
      sessionInfoJson.JsonObject.SessionInfo.Property.length;
    for (let i = 0; i < propertyLength; ++i) {
      const sessionInfoName =
        sessionInfoJson.JsonObject.SessionInfo.Property[i]['@attributes'][
          'name'
        ];
      const sessionInfoValue =
        sessionInfoJson.JsonObject.SessionInfo.Property[i]['@attributes'][
          'value'
        ];

      switch (sessionInfoName) {
        case 'userId':
          this.sessionInfo.userId = sessionInfoValue;
          break;
        case 'firstName':
          this.sessionInfo.firstName = sessionInfoValue;
          break;
        case 'lastName':
          this.sessionInfo.lastName = sessionInfoValue;
          break;
        case 'authenticated':
          this.sessionInfo.authenticated = sessionInfoValue;
          break;
        case 'activityState':
          this.sessionInfo.activityState = sessionInfoValue;
          break;
        case 'receiveReady':
          this.sessionInfo.receiveReady = sessionInfoValue;
          break;
        case 'sipRegistered':
          this.sessionInfo.sipRegistered = sessionInfoValue;
          break;
        case 'sipUser':
          this.sessionInfo.sipUser = sessionInfoValue;
          break;
        case 'onCall':
          this.sessionInfo.onCall = sessionInfoValue;
          break;
        case 'currentCallId':
          this.sessionInfo.currentCallId = sessionInfoValue;
          break;
        case 'tenantId':
          this.sessionInfo.tenantId = sessionInfoValue;
          break;
        case 'agentId':
          this.sessionInfo.agentId = sessionInfoValue;
          break;
        case 'allowManualCalls':
          this.sessionInfo.allowManualCalls = sessionInfoValue === 'True';
          break;
        case 'language':
          this.sessionInfo.language = sessionInfoValue;
          break;
      }
    }
  }
  createProfileStats(profileStats: any) {
    this.statsInfo = {
      profileStatsInfo: {},
      sessionStatsInfo: {},
    } as StatsInfo;
    this.statsInfo.profileStatsInfo.profileId =
      profileStats['@attributes']['profileId'];
    const statsLength = profileStats.Stat.length;

    for (let i = 0; i < statsLength; ++i) {
      const statsInfoName = profileStats.Stat[i]['@attributes']['name'];
      const statsInfoValue = profileStats.Stat[i]['@attributes']['value'];

      switch (statsInfoName.toUpperCase()) {
        case 'CALLCOUNT':
          this.statsInfo.profileStatsInfo.callCount = statsInfoValue * 1;
          break;
        case 'CONTACTS':
          this.statsInfo.profileStatsInfo.contacts = statsInfoValue;
          break;
        case 'DIALTIME':
          this.statsInfo.profileStatsInfo.dialTime = statsInfoValue;
          break;
        case 'PITCH':
          this.statsInfo.profileStatsInfo.pitch = statsInfoValue;
          break;
        case 'SALECOUNT':
          this.statsInfo.profileStatsInfo.saleCount = statsInfoValue * 1;
          break;
        case 'TALKTIME':
          this.statsInfo.profileStatsInfo.talkTime = statsInfoValue * 1;
          break;
        case 'VERIFIED':
          this.statsInfo.profileStatsInfo.verified = statsInfoValue * 1;
          break;
        case 'WRAPUPTIME':
          this.statsInfo.profileStatsInfo.wrapupTime = statsInfoValue * 1;
          break;
      }
    }
    return this.statsInfo.profileStatsInfo;
  }
  handleResponseInfoStats(usmMessage: UsmMessage) {
    const text = usmMessage.Xml;
    const statsInfoJson = new XmlToJsonParser();
    if (text) {
      statsInfoJson.Parse(text);
      this.handleProfileStats(statsInfoJson);
      this.handleSessionStats(statsInfoJson);
    }
  }
  handleSessionStats(statsInfoJson: any) {
    // calculated stats
    this.sessionStatsInfo.averageTalkTime = 0;
    this.sessionStatsInfo.averageWaitTime = 0;
    this.sessionStatsInfo.averageWrapupTime = 0;
    this.sessionStatsInfo.totalCalls = 0;
    this.sessionStatsInfo.totalSales = 0;
    this.sessionStatsInfo.totalTalkTime = 0;
    this.sessionStatsInfo.totalWrapupTime = 0;

    for (const element of this.profileStatsInfo ?? []) {
      let profileStats = element;
      this.sessionStatsInfo.totalCalls += profileStats.callCount;
      this.sessionStatsInfo.totalSales += profileStats.saleCount;
      this.sessionStatsInfo.totalTalkTime += profileStats.talkTime;
      this.sessionStatsInfo.totalWrapupTime += profileStats.wrapupTime;
    }

    // sessionStats
    let statLength = statsInfoJson?.Stat?.length;
    for (let i = 0; i < statLength; ++i) {
      let statsInfoName = statsInfoJson.Stat[i]['@attributes']['name'];
      let statsInfoValue = statsInfoJson.Stat[i]['@attributes']['value'];

      switch (statsInfoName.toUpperCase()) {
        case 'BREAKTIME':
          this.sessionStatsInfo.breakTime = statsInfoValue;
          break;
        case 'LOGIN-AGENT':
          this.sessionStatsInfo.loginTime = statsInfoValue;
          break;
        case 'STATE-IDLE':
          this.sessionStatsInfo.idleTime = statsInfoValue;
          break;
        case 'VOICEMAIL':
          this.sessionStatsInfo.voicemailTime = statsInfoValue;
          break;
        case 'WAITTIME':
          this.sessionStatsInfo.waitTime = statsInfoValue;
          break;
      }
    }

    // averages
    if (
      this.sessionStatsInfo.totalTalkTime > 0 &&
      this.sessionStatsInfo.totalCalls > 0
    ) {
      this.sessionStatsInfo.averageTalkTime = Math.round(
        this.sessionStatsInfo.totalTalkTime / this.sessionStatsInfo.totalCalls
      );
    }

    if (
      this.sessionStatsInfo.waitTime !== null &&
      this.sessionStatsInfo.waitTime > 0 &&
      this.sessionStatsInfo.totalCalls > 0
    ) {
      this.sessionStatsInfo.averageWaitTime = Math.round(
        this.sessionStatsInfo.waitTime / this.sessionStatsInfo.totalCalls
      );
    }

    if (
      this.sessionStatsInfo.totalWrapupTime !== null &&
      this.sessionStatsInfo.totalWrapupTime > 0 &&
      this.sessionStatsInfo.totalCalls > 0
    ) {
      this.sessionStatsInfo.averageWrapupTime = Math.round(
        this.sessionStatsInfo.totalWrapupTime / this.sessionStatsInfo.totalCalls
      );
    }
  }
  handleProfileStats(statsInfoJson: any) {
    this.profileStatsInfo = new Array();
    if (typeof statsInfoJson.JsonObject.StatsInfo.ProfileStats === 'object') {
      if (
        typeof statsInfoJson.JsonObject.StatsInfo.ProfileStats.length ===
        'undefined'
      ) {
        const profileStats = statsInfoJson.JsonObject.StatsInfo.ProfileStats;
        this.profileStatsInfo.push(this.createProfileStats(profileStats));
      } else {
        for (let bb in statsInfoJson.JsonObject.StatsInfo.ProfileStats) {
          let profileStats =
            statsInfoJson.JsonObject.StatsInfo.ProfileStats[bb];
          this.profileStatsInfo.push(this.createProfileStats(profileStats));
        }
      }
    }
  }
  handleResponseDialConf(usmMessage: UsmMessage) {
    this.conferenceInfo = {} as ConferenceInfo;
    this.conferenceInfo.callId = usmMessage.CallId;
    this.conferenceInfo.contactId = usmMessage.Get('ContactId');
    this.conferenceInfo.contactNumber = usmMessage.Get('ContactNumber');
    this.conferenceInfo.profileId = usmMessage.Get('ProfileId');
    this.conferenceInfo.profileDialType = usmMessage.Get('ProfileDialType');
  }
  handleResponseDialTransfer(usmMessage: UsmMessage) {
    this.transferInfo = {} as TransferInfo;
    this.transferInfo.callId = usmMessage.CallId;
    this.transferInfo.contactId = usmMessage.Get('ContactId');
    this.transferInfo.contactNumber = usmMessage.Get('ContactNumber');
    this.transferInfo.profileId = usmMessage.Get('ProfileId');
    this.transferInfo.profileDialType = usmMessage.Get('ProfileDialType');
  }
  handleCallInfo(usmMessage: UsmMessage) {
    this.callInfo = {} as CallInfo;
    this.initializeCallInfo(this.callInfo, usmMessage);

    this.lookupProfile();
    if (!this.callInfo.profile?.type) {
      this.callInfo.profile.type = usmMessage?.Data?.ProfileId?.split('-')?.[0];
    }
    this.callInfo.isRecording = this.callInfo.profile?.controlledRecording;

    if (usmMessage.Xml) {
      const callDataJson = new XmlToJsonParser();
      callDataJson.Parse(usmMessage.Xml);

      this.parsePostCalls(callDataJson);
      this.parsePlaybacks(callDataJson);
    }
  }

  private initializeCallInfo(callInfo: CallInfo, usmMessage: UsmMessage) {
    callInfo.callId = usmMessage.CallId;
    callInfo.contactId = usmMessage.Get('ContactId');
    callInfo.contactNumber = usmMessage.Get('ContactNumber');
    callInfo.countryCode = usmMessage.Get('CountryCode');
    callInfo.languageCode = usmMessage.Get('LanguageCode');
    callInfo.isTransferred = usmMessage.Get('IsTransferred') === 'True';
    callInfo.isUsingTenantScriptUrl = '';
    callInfo.playbacks = new Array();
    callInfo.postcalls = new Array();
    callInfo.profileId = usmMessage.Get('ProfileId');
    callInfo.profileDialType = usmMessage.Get('ProfileDialType');
    callInfo.supervisedTransfer = null as unknown as string;
  }
  private lookupProfile() {
    const profile = this.profilesInfo?.Profiles?.find(
      p => p.id === this.callInfo.profileId
    );
    if (profile) {
      this.callInfo.profile = profile;
    } else {
      this.callInfo.profile = {} as Profile;
    }
  }

  handleTransferAgentProfile(usmMessage: UsmMessage) {
    const profileInfo = usmMessage.RawMessage;
    if (profileInfo?.includes('Script:')) {
      const jsonPart = profileInfo?.replace(/^Script:/, '') || '{}';
      const parsedData = JSON.parse(jsonPart);
      this.callInfo.profile.disallowManualCalls =
        parsedData?.['DisallowManualCalls'];
      this.callInfo.profile.externalScript = parsedData?.['IsExternalScript'];
      this.callInfo.profile.controlledRecording =
        parsedData?.['RecordAllCalls'];
      this.callInfo.isRecording = parsedData?.['RecordAllCalls'];
      this.callInfo.profile.externalScriptIsRedirect =
        parsedData?.['IsExternalScriptRedirect'];
      this.callInfo.profile.hasCustomScripting =
        parsedData?.['IsExternalScript'];
      this.callInfo.profile.customScriptingUrl = parsedData?.['ScriptUrl'];
      this.callInfo.profile.type = parsedData?.['ProfileType'];
      this.callInfo.profileDialType = parsedData?.['DialType'];
      this.callInfo.isTransferred = true;

      if (this.callInfo.profile.type == 'inbound') {
        this.setContactNumber(
          parsedData,
          'OverrideTransferCallerId',
          'OutsideNumber'
        );
      } else {
        this.setContactNumber(
          parsedData,
          'OverrideTransferCallerIdType',
          'OverrideTransferCallerId'
        );
      }
    }
  }

  // eslint-disable-next-line
  setContactNumber(parsedData: any, setproperty: string, getProperty: string) {
    if (parsedData?.[setproperty] == 'profile') {
      this.callInfo.contactNumber = parsedData?.['CallerId'];
    }
    if (parsedData?.[setproperty] == 'override') {
      this.callInfo.contactNumber = parsedData?.[getProperty];
    }
  }

  private parsePostCalls(callDataJson: XmlToJsonParser) {
    const pca = callDataJson.JsonObject.CallData.PostCallAction;
    if (typeof pca === 'object') {
      const pcaArray = Array.isArray(pca) ? pca : [pca];
      for (const pcaItem of pcaArray) {
        const postcall = {
          data: pcaItem,
          type: pcaItem['@attributes']['type'],
          value: pcaItem['#text'],
          dispositionCodes: pcaItem['@attributes']['dispositions']
            .split(',')
            .map((code: string) => code.trim()),
        };
        if (
          this.callInfo.supervisedTransfer === null &&
          postcall.type === 'stransfer'
        ) {
          this.callInfo.supervisedTransfer = postcall as unknown as string;
        }
        this.callInfo.postcalls.push(postcall);
      }
    }
  }

  private parsePlaybacks(callDataJson: XmlToJsonParser) {
    const playbacks = callDataJson.JsonObject.CallData.Playbacks.Playback;
    if (typeof playbacks === 'object') {
      const playbackArray = Array.isArray(playbacks) ? playbacks : [playbacks];
      for (const playbackItem of playbackArray) {
        const playback = {
          autoDisconnect:
            playbackItem['@attributes']['autoDisconnect'] === 'True',
          autoMute: playbackItem['@attributes']['autoMute'] === 'True',
          durationSeconds: playbackItem['@attributes']['durationSeconds'],
          fileName: playbackItem['@attributes']['fileName'],
          id: playbackItem['@attributes']['id'],
          name: playbackItem['@attributes']['name'],
        };
        this.callInfo.playbacks.push(playback);
      }
    }
  }
  closeUsmConnection() {
    console.log('close usm connection');
    if (this.usmSocket && this.usmSocket.readyState === 1) {
      this.usmSocket?.close();
    }
    this.usmSocket= null;
    this.reset();
  }
  logOff(origin?: string) {
    console.log(`Logout USM Request => Initiated from : ${origin} on ${new Date()}`);
    if (this.usmSocket?.readyState == 1) {
      this.usmSocket?.send(Logout());
      console.log(`Logout USM Request => Send from : ${origin} on ${new Date()}`);
    }
  }
}
